import Axios from '@/axios'

//设置组织导航图片顺序
export const createNavigateOrder = data => {
  return Axios({
    url: '/face/web/navigate/create_dept_navigate_photo_order',
    method: 'POST',
    type: 'json',
    data
  })
}
//创建导航图片
export const createGuideMap = data => {
  return Axios({
    url: '/face/web/navigate/create_navigate_photo',
    method: 'POST',
    type: 'json',
    data
  })
}
//删除组织导航图片顺序
export const deleteGuideMapCompanyOrder = data => {
  return Axios({
    url: '/face/web/navigate/delete_dept_navigate_photo_order',
    method: 'POST',
    type: 'json',
    data
  })
}
//删除导航图片，同时oss删除图片
export const deleteGuideMap = id => {
  return Axios({
    url: `/face/web/navigate/delete_navigate_photo/${id}`,
    method: 'POST',
    type: 'json',
    data: {}
  })
}
//查询导航图片
export const getGuideMap = data => {
  return Axios({
    url: '/face/web/navigate/index_navigate_photo',
    method: 'POST',
    type: 'json',
    data
  })
}

//查询组织导航图片
export const getGuideMapList = data => {
  return Axios({
    url: '/face/web/navigate/show_dept_navigate_photo_order',
    method: 'POST',
    type: 'json',
    data
  })
}
